// ISO 3166-1 alpha-2 country codes
export const COUNTRY_CODES = {
  // Common variations and full list
  'afghanistan': 'AF',
  'albania': 'AL',
  'algeria': 'DZ',
  'andorra': 'AD',
  'angola': 'AO',
  'antigua and barbuda': 'AG',
  'antiguaandbarbuda': 'AG',
  'argentina': 'AR',
  'armenia': 'AM',
  'australia': 'AU',
  'austria': 'AT',
  'azerbaijan': 'AZ',
  'bahamas': 'BS',
  'bahrain': 'BH',
  'bangladesh': 'BD',
  'barbados': 'BB',
  'belarus': 'BY',
  'belgium': 'BE',
  'belize': 'BZ',
  'benin': 'BJ',
  'bhutan': 'BT',
  'bolivia': 'BO',
  'bosnia and herzegovina': 'BA',
  'bosniaandherzegovina': 'BA',
  'botswana': 'BW',
  'brazil': 'BR',
  'brunei': 'BN',
  'bulgaria': 'BG',
  'burkina faso': 'BF',
  'burkinafaso': 'BF',
  'burundi': 'BI',
  'cambodia': 'KH',
  'cameroon': 'CM',
  'canada': 'CA',
  'cape verde': 'CV',
  'capeverde': 'CV',
  'central african republic': 'CF',
  'chad': 'TD',
  'chile': 'CL',
  'china': 'CN',
  'colombia': 'CO',
  'comoros': 'KM',
  'congo': 'CG',
  'costa rica': 'CR',
  'costarica': 'CR',
  'croatia': 'HR',
  'cuba': 'CU',
  'cyprus': 'CY',
  'czech republic': 'CZ',
  'czechrepublic': 'CZ',
  'czechia': 'CZ',
  'denmark': 'DK',
  'djibouti': 'DJ',
  'dominica': 'DM',
  'dominican republic': 'DO',
  'dominicanrepublic': 'DO',
  'east timor': 'TL',
  'easttimor': 'TL',
  'ecuador': 'EC',
  'egypt': 'EG',
  'el salvador': 'SV',
  'elsalvador': 'SV',
  'england': 'gb-eng',
  'equatorial guinea': 'GQ',
  'eritrea': 'ER',
  'estonia': 'EE',
  'ethiopia': 'ET',
  'fiji': 'FJ',
  'finland': 'FI',
  'france': 'FR',
  'gabon': 'GA',
  'gambia': 'GM',
  'georgia': 'GE',
  'germany': 'DE',
  'ghana': 'GH',
  'greece': 'GR',
  'grenada': 'GD',
  'guatemala': 'GT',
  'guinea': 'GN',
  'guinea bissau': 'GW',
  'guineabissau': 'GW',
  'guyana': 'GY',
  'haiti': 'HT',
  'honduras': 'HN',
  'hungary': 'HU',
  'iceland': 'IS',
  'india': 'IN',
  'indonesia': 'ID',
  'iran': 'IR',
  'iraq': 'IQ',
  'ireland': 'IE',
  'israel': 'IL',
  'italy': 'IT',
  'ivory coast': 'CI',
  'ivorycoast': 'CI',
  'jamaica': 'JM',
  'japan': 'JP',
  'jordan': 'JO',
  'kazakhstan': 'KZ',
  'kenya': 'KE',
  'kiribati': 'KI',
  'korea': 'KR',
  'south korea': 'KR',
  'southkorea': 'KR',
  'north korea': 'KP',
  'northkorea': 'KP',
  'kosovo': 'XK',
  'kuwait': 'KW',
  'kyrgyzstan': 'KG',
  'laos': 'LA',
  'latvia': 'LV',
  'lebanon': 'LB',
  'lesotho': 'LS',
  'liberia': 'LR',
  'libya': 'LY',
  'liechtenstein': 'LI',
  'lithuania': 'LT',
  'luxembourg': 'LU',
  'macedonia': 'MK',
  'madagascar': 'MG',
  'malawi': 'MW',
  'malaysia': 'MY',
  'maldives': 'MV',
  'mali': 'ML',
  'malta': 'MT',
  'marshall islands': 'MH',
  'mauritania': 'MR',
  'mauritius': 'MU',
  'mexico': 'MX',
  'micronesia': 'FM',
  'moldova': 'MD',
  'monaco': 'MC',
  'mongolia': 'MN',
  'montenegro': 'ME',
  'morocco': 'MA',
  'mozambique': 'MZ',
  'myanmar': 'MM',
  'namibia': 'NA',
  'nauru': 'NR',
  'nepal': 'NP',
  'netherlands': 'NL',
  'new zealand': 'NZ',
  'newzealand': 'NZ',
  'nicaragua': 'NI',
  'niger': 'NE',
  'nigeria': 'NG',
  'norway': 'NO',
  'oman': 'OM',
  'pakistan': 'PK',
  'palau': 'PW',
  'palestine': 'PS',
  'panama': 'PA',
  'papua new guinea': 'PG',
  'papuanewguinea': 'PG',
  'paraguay': 'PY',
  'peru': 'PE',
  'philippines': 'PH',
  'poland': 'PL',
  'portugal': 'PT',
  'qatar': 'QA',
  'romania': 'RO',
  'russia': 'RU',
  'rwanda': 'RW',
  'saint kitts and nevis': 'KN',
  'saint lucia': 'LC',
  'saint vincent': 'VC',
  'samoa': 'WS',
  'san marino': 'SM',
  'sanmarino': 'SM',
  'sao tome': 'ST',
  'saudi arabia': 'SA',
  'saudiarabia': 'SA',
  'scotland': 'gb-sct',
  'senegal': 'SN',
  'serbia': 'RS',
  'seychelles': 'SC',
  'sierra leone': 'SL',
  'sierraleone': 'SL',
  'singapore': 'SG',
  'slovakia': 'SK',
  'slovenia': 'SI',
  'solomon islands': 'SB',
  'somalia': 'SO',
  'south africa': 'ZA',
  'southafrica': 'ZA',
  'south sudan': 'SS',
  'southsudan': 'SS',
  'spain': 'ES',
  'sri lanka': 'LK',
  'srilanka': 'LK',
  'sudan': 'SD',
  'suriname': 'SR',
  'swaziland': 'SZ',
  'sweden': 'SE',
  'switzerland': 'CH',
  'syria': 'SY',
  'taiwan': 'TW',
  'tajikistan': 'TJ',
  'tanzania': 'TZ',
  'thailand': 'TH',
  'timor leste': 'TL',
  'togo': 'TG',
  'tonga': 'TO',
  'trinidad and tobago': 'TT',
  'trinidadandtobago': 'TT',
  'tunisia': 'TN',
  'turkey': 'TR',
  'turkmenistan': 'TM',
  'tuvalu': 'TV',
  'uganda': 'UG',
  'ukraine': 'UA',
  'united arab emirates': 'AE',
  'unitedarabemirates': 'AE',
  'uae': 'AE',
  'united kingdom': 'GB',
  'unitedkingdom': 'GB',
  'uk': 'GB',
  'united states': 'US',
  'unitedstates': 'US',
  'usa': 'US',
  'uruguay': 'UY',
  'uzbekistan': 'UZ',
  'vanuatu': 'VU',
  'vatican': 'VA',
  'venezuela': 'VE',
  'vietnam': 'VN',
  'wales': 'gb-wls',
  'zambia': 'ZM',
  'zimbabwe': 'ZW',
  
  // 3-Letter Codes (Sportradar/IOC)
  'afg': 'AF', 'alb': 'AL', 'alg': 'DZ', 'and': 'AD', 'ang': 'AO', 'arg': 'AR', 'arm': 'AM',
  'aus': 'AU', 'aut': 'AT', 'aze': 'AZ', 'bah': 'BS', 'ban': 'BD', 'bar': 'BB', 'blr': 'BY',
  'bel': 'BE', 'ben': 'BJ', 'bhu': 'BT', 'bol': 'BO', 'bih': 'BA', 'bot': 'BW', 'bra': 'BR',
  'brn': 'BN', 'bul': 'BG', 'bur': 'BF', 'bdi': 'BI', 'cam': 'KH', 'cmr': 'CM', 'can': 'CA',
  'cpv': 'CV', 'caf': 'CF', 'cha': 'TD', 'chi': 'CL', 'chn': 'CN', 'col': 'CO', 'com': 'KM',
  'cgo': 'CG', 'crc': 'CR', 'cro': 'HR', 'cub': 'CU', 'cyp': 'CY', 'cze': 'CZ', 'den': 'DK',
  'dji': 'DJ', 'dma': 'DM', 'dom': 'DO', 'tls': 'TL', 'ecu': 'EC', 'egy': 'EG', 'esa': 'SV',
  'eng': 'gb-eng', 'geq': 'GQ', 'eri': 'ER', 'est': 'EE', 'eth': 'ET', 'fij': 'FJ', 'fin': 'FI',
  'fra': 'FR', 'gab': 'GA', 'gam': 'GM', 'geo': 'GE', 'ger': 'DE', 'deu': 'DE', 'gha': 'GH',
  'gre': 'GR', 'grn': 'GD', 'gua': 'GT', 'gui': 'GN', 'gbs': 'GW', 'guy': 'GY', 'hai': 'HT',
  'hon': 'HN', 'hun': 'HU', 'isl': 'IS', 'ind': 'IN', 'ina': 'ID', 'idn': 'ID', 'iri': 'IR',
  'irq': 'IQ', 'irl': 'IE', 'isr': 'IL', 'ita': 'IT', 'civ': 'CI', 'jam': 'JM', 'jpn': 'JP',
  'jor': 'JO', 'kaz': 'KZ', 'ken': 'KE', 'kir': 'KI', 'kor': 'KR', 'prk': 'KP', 'kos': 'XK',
  'kuw': 'KW', 'kgz': 'KG', 'lao': 'LA', 'lat': 'LV', 'lbn': 'LB', 'les': 'LS', 'lbr': 'LR',
  'lby': 'LY', 'lie': 'LI', 'ltu': 'LT', 'lux': 'LU', 'mkd': 'MK', 'mad': 'MG', 'maw': 'MW',
  'mas': 'MY', 'mdv': 'MV', 'mli': 'ML', 'mlt': 'MT', 'mhl': 'MH', 'mtn': 'MR', 'mri': 'MU',
  'mex': 'MX', 'fsm': 'FM', 'mda': 'MD', 'mon': 'MC', 'mgl': 'MN', 'mne': 'ME', 'mar': 'MA',
  'moz': 'MZ', 'mya': 'MM', 'nam': 'NA', 'nru': 'NR', 'nep': 'NP', 'ned': 'NL', 'nld': 'NL',
  'nzl': 'NZ', 'nca': 'NI', 'nig': 'NE', 'ngr': 'NG', 'nor': 'NO', 'oma': 'OM', 'pak': 'PK',
  'plw': 'PW', 'ple': 'PS', 'pan': 'PA', 'png': 'PG', 'par': 'PY', 'per': 'PE', 'phi': 'PH',
  'pol': 'PL', 'por': 'PT', 'qat': 'QA', 'rou': 'RO', 'rus': 'RU', 'rwa': 'RW', 'skn': 'KN',
  'lca': 'LC', 'vin': 'VC', 'sam': 'WS', 'smr': 'SM', 'stp': 'ST', 'ksa': 'SA', 'sco': 'gb-sct',
  'sen': 'SN', 'srb': 'RS', 'sey': 'SC', 'sle': 'SL', 'sgp': 'SG', 'svk': 'SK', 'slo': 'SI',
  'sol': 'SB', 'som': 'SO', 'rsa': 'ZA', 'ssd': 'SS', 'esp': 'ES', 'sri': 'LK', 'sud': 'SD',
  'sur': 'SR', 'swz': 'SZ', 'swe': 'SE', 'sui': 'CH', 'che': 'CH', 'syr': 'SY', 'tpe': 'TW',
  'tjk': 'TJ', 'tan': 'TZ', 'tha': 'TH', 'tog': 'TG', 'tga': 'TO', 'tto': 'TT', 'tun': 'TN',
  'tur': 'TR', 'tkm': 'TM', 'tuv': 'TV', 'uga': 'UG', 'ukr': 'UA', 'gbr': 'GB',
  'uru': 'UY', 'uzb': 'UZ', 'van': 'VU', 'ven': 'VE', 'vie': 'VN', 'wal': 'gb-wls',
  'yem': 'YE', 'zam': 'ZM', 'zim': 'ZW'
};

export const getCountryCode = (teamName) => {
  const normalized = teamName.toLowerCase().replace(/[^a-z]/g, '');
  return COUNTRY_CODES[normalized] || COUNTRY_CODES[teamName.toLowerCase()] || null;
};

export const getFlagEmoji = (teamName) => {
  const code = getCountryCode(teamName);
  if (!code) return '🏳️';

  // Special case for England, Scotland, Wales
  if (teamName.toLowerCase() === 'england') return '🏴󠁧󠁢󠁥󠁮󠁧󠁿';
  if (teamName.toLowerCase() === 'scotland') return '🏴󠁧󠁢󠁳󠁣󠁴󠁿';
  if (teamName.toLowerCase() === 'wales') return '🏴󠁧󠁢󠁷󠁬󠁳󠁿';

  const codePoints = code
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
};
